import { Box, Grid, Typography } from "@mui/material";
import ProjectsItem from "./ProjectsItem";
import notions from "../api/notions";
import CustomButton from "../mui-styles/CustomButton";

export default function Projects({ keyword, itemPerPage, onLoadMoreBtn }) {
  // filtering keywords to searc
  const filteredKeyword = notions.filter((notion) => {
    const multipleProperties = [
      notion.title,
      notion.description,
      ...notion.hashtag,
    ];
    const keywordLowerCase = keyword.toLowerCase();

    return multipleProperties.some(
      (property) =>
        typeof property === "string" &&
        property.toLowerCase().includes(keywordLowerCase)
    );
  });

  const renderFilteredKeyword =
    filteredKeyword.length > 0 ? (
      filteredKeyword.slice(0, itemPerPage).map((filteredItem, index) => {
        return (
          <Grid item xs={12} sm={6} md={5} key={index}>
            <ProjectsItem notion={filteredItem} />
          </Grid>
        );
      })
    ) : (
      <Typography variant="h5" component="div" sx={{ p: 10 }}>
        No results found...
      </Typography>
    );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={{ xs: 2, md: 3 }}
      >
        {renderFilteredKeyword}
      </Grid>
      <Grid p={2}>
        <CustomButton variant="contained" size="large" onClick={onLoadMoreBtn}>
          Load More
        </CustomButton>
      </Grid>
    </Box>
  );
}

// const renderProjects = notions.map((notion, index) => {
// return (
//   <Grid item xs={12} sm={6} md={5} key={index}>
//     <ProjectsItem
//       notion={notion}
//       keyword={keyword}
//       itemPerPage={itemPerPage}
//       onLoadMoreBtn={onLoadMoreBtn}
//     />
//   </Grid>
// );
// });
